import React, { useEffect, useState, PureComponent, useContext } from 'react';
import { useParams } from 'react-router-dom';

import { AuthContext } from '../context/AuthContext';

import module from '../assets/module.svg';
import rocket from '../assets/rocket.png';
import user from '../assets/user.png';

import { ReactComponent as Eye } from '../assets/eye.svg';
import { ReactComponent as Qrcode } from '../assets/qrcode_small.svg';
import { ReactComponent as Add } from '../assets/add_black.svg';
import { ReactComponent as Cancel } from '../assets/cancel.svg';
import { ReactComponent as EditPurple } from '../assets/edit_purple.svg';
import { ReactComponent as QrcodePurple } from '../assets/qrcode_purple.svg';
import { ReactComponent as Remove } from '../assets/remove.svg';
import { ReactComponent as EditSvg } from '../assets/edit.svg';

import poll from '../assets/poll_big.png';
import questions from '../assets/questions_big.png';
import video from '../assets/video_big.png';
import download from '../assets/download_big.png';
import profile from '../assets/profile_big.png';
import AR from '../assets/AR_big.png';
import photobooth from '../assets/photobooth_big.png';
import matchgame from '../assets/matchgame_big.png';


export default function ActivitySelection ({showActivitySettings, close}) {

    const { currentUser, user } = useContext(AuthContext);

    const premiumActivities = process.env.REACT_APP_PREMIUM_ACTIVITIES;

    const activities = [
        {
            code: "/quiz",
            title: "Quiz",
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
            image: questions,
        },
        {
            code: "/poll",
            title: "Poll",
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
            image: poll,
        },
        {
            code: "/video",
            title: "Video",
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
            image: video,
        },
        {
            code: "/mint",
            title: "Mint",
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
            image: false,
        },
        {
            code: "/bio",
            title: "Bio",
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
            image: false,
        },
        {
            code: "/download",
            title: "Download",
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
            image: download,
        },
        {
            code: "/profile",
            title: "Profile input",
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
            image: profile,
        },
        {
            code: "/ar",
            title: "AR",
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
            image: AR,
        },
        {
            code: "/photobooth",
            title: "Photobooth",
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
            image: photobooth,
        },
        {
            code: "/matchgame",
            title: "Match game",
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
            image: matchgame,
        }
    ];

    
    return (        
        
        <div className="right">                                                                         
        
            <div className="activities dashed-border"> 
        
                <div className="title"> 
                    <div>
                        <div className="name">Select new activity</div>
                    </div>
                    <div>
                        <div className="cancel" onClick={close}>
                            <Cancel/>
                            Cancel
                        </div>                                            
                    </div>
                </div>

                {activities.map((activity, activityIndex) =>

                    <div key={activityIndex} className="new-activity" onClick={() => showActivitySettings(activity.code)}>
                        <div className="icon">
                            {
                                activity.image &&
                                    <img src={activity.image} alt="" />
                            }
                        </div>
                        <div>
                            <div className="title">{activity.title}</div>
                            <div className="description">{activity.description}</div>
                        </div>

                        {user.account != 'premium' && premiumActivities.includes(activity.code) &&
                            <div className="unlock">
                                Unlock Activity
                            </div>
                        }

                    </div>
                )}

                
            </div>
            
        </div>      
        
    )

}
